export const PATTERN_GRID_SIZE = 9

export const emptyPatternCells = (): boolean[] => Array(PATTERN_GRID_SIZE).fill(false)

export const patternFromCells = (cells: boolean[]): string =>
  cells.map(cell => (cell ? '1' : '0')).join('')

export const hasMarkedCell = (cells: boolean[]): boolean => cells.some(Boolean)
